import React, { useContext, useState } from 'react';
import { InputField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import { maskSsnForDisplay, mapCitizenshipToSsnLabel } from './util';
import {
  formatSsnForDisplay,
  handleInputFormat
} from '../../flows/shared/utils';
import { middlenameValidation } from '../../flows/shared/validations';
import styles from './style.css';
import { withDefault } from '../../core/util';
import { CitizenshipSection } from './PersonalInformationSection';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const TrusteeInformationSection = () => {
  const { formProps, appState } = useContext(FlowContext);
  const {
    store: {
      app,
      enabled,
      authenticated,
      loadedData: { citizenShipPresent }
    }
  } = appState;
  const {
    trustee: {
      name: { firstName, lastName, middleName },
      dob,
      taxID,
      citizenship
    }
  } = app;

  const [ssnLabel, setSsnLabel] = useState(
    mapCitizenshipToSsnLabel(citizenship)
  );
  const [dobValue, setDobValue] = useState('');
  const [ssnValue, setSSNValue] = useState('');

  const handleCitizenshipBtnClick = ({ target: { value } }) =>
    setSsnLabel(mapCitizenshipToSsnLabel(value));

  return (
    <>
      <div className="name-fields">
        <div className="first-name">
          <InputField
            type="text"
            title="First Name"
            {...formProps.firstName}
            defaultValue={firstName}
            disabled={enabled}
            className="blocked_data"
            data-name={generateGeneralTestID(
              'TrusteePersonalInformation',
              'FirstName'
            )}
          />
        </div>

        <div className="middle-name">
          <InputField
            type="text"
            title="Middle Name"
            {...formProps.middleName}
            defaultValue={middleName}
            disabled={enabled}
            validation={middlenameValidation}
            className="blocked_data"
            data-name={generateGeneralTestID(
              'TrusteePersonalInformation',
              'MiddleName'
            )}
          />
        </div>
        <div className="last-name">
          <InputField
            type="text"
            title="Last Name"
            {...formProps.lastName}
            defaultValue={lastName}
            disabled={enabled}
            className="blocked_data"
            data-name={generateGeneralTestID(
              'TrusteePersonalInformation',
              'LastName'
            )}
          />
        </div>
      </div>
      <div className="personal-info-fields">
        <div className="dob-input">
          <InputField
            style={{ paddingRight: '8px' }}
            type="text"
            title="Date of Birth"
            aria-describedby="hint"
            {...formProps.dob}
            value={withDefault(dobValue, dob)}
            disabled={enabled}
            maxLength="10"
            onChange={evt => handleInputFormat(evt, 'DATE', setDobValue)}
            placeholder="mm/dd/yyyy"
            className="blocked_data"
            data-name={generateGeneralTestID(
              'TrusteePersonalInformation',
              'BirthDate'
            )}
          />
          <dd id="hint" style={{ display: 'none' }}>
            This is a required field. Please enter a two digit month, a two
            digit day and a four digit year for the Date of Birth value.
          </dd>
        </div>
        <div className="ssn-input">
          <InputField
            title={ssnLabel}
            name="ssn-input"
            placeholder="000-00-0000"
            maxLength="11"
            onChange={evt => handleInputFormat(evt, 'SSN', setSSNValue)}
            {...formProps.ssn}
            value={
              enabled
                ? maskSsnForDisplay(taxID)
                : withDefault(ssnValue, formatSsnForDisplay(taxID))
            }
            disabled={enabled}
            className="blocked_data"
            data-name={generateGeneralTestID(
              'TrusteePersonalInformation',
              'TaxID'
            )}
          />
        </div>
        <CitizenshipSection
          authenticated={authenticated}
          citizenship={citizenship}
          citizenShipPresent={citizenShipPresent}
          handleCitizenshipBtnClick={handleCitizenshipBtnClick}
          dataNamePrefix="TrusteePersonalInformation"
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default TrusteeInformationSection;
